// extracted by mini-css-extract-plugin
export default {"Agenda":"Agenda_Agenda__hK+WM","Topic":"Agenda_Topic__-l0k6"};